import { useState, useEffect, useRef, useContext } from "react";
import { Row, Col, Button, Form, Alert, Modal, ProgressBar, Card } from "react-bootstrap";

import _ from "lodash";
import axios from "axios";
import moment from "moment";  
import Utils from "../../common/Utils";
import { UserContext } from "../../common";

const RotaNote = (props) => {
  const viewOnly = props.viewOnly;
  const { userData } = useContext(UserContext);
  const [mode, setMode] = useState(_.get(props,'note.id','0') === '0' ? 1 : 0);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  const saveRotaNote = (e) => {
    e.preventDefault();
    let frm = e.currentTarget;
    setSaving(true);
    const pvals = {
      rnid: _.get(props,'note.id','0'),
      rota_date: moment(props.dt).format("YYYY-MM-DD"),
      branch_id: props.branch_id,
      note: frm.note.value
    };

    if (pvals.note === "") {
      setMessage("Please enter a note");
      setSaving(false);
      return;
    }

    axios
      .post(
        Utils.apiUrl("users/saveRotaNote"),
        Utils.postVars(pvals),
        Utils.apiHeaders()
      )
      .then((res) => {
        setSaving(false);
        if(res.data.success) {
          props.afterSave(res.data.rotanote);
          props.onHide();
        }
      })
      .catch((err) => {
        setSaving(false);
        setMessage(err.message);
        console.log(err);
      });
  };

  const deleteNote = (e) => {
    if(window.confirm("Are you sure you want to delete this note?")) {
      setSaving(true);

      axios
        .delete(
          Utils.apiUrl("users/delRotaNote/"+_.get(props,'note.id','0')),
          Utils.apiHeaders()
        )
        .then((res) => {
          setSaving(false);
          if(res.data.success) {
            props.afterSave();
            props.onHide();
            alert("Note deleted successfully");
          }
        })
        .catch((err) => {
          setSaving(false);
          setMessage(err.message);
          console.log(err);
        });
    }
  };
  
  return (
    <>
      <Modal show size="lg" onHide={props.onHide} centered>
        <Form className="needs-validation" onSubmit={saveRotaNote}>
          <Modal.Header closeButton>
            <Modal.Title>Note for {moment(props.dt).format("DD MMM, YYYY")}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="bg-white">
            <Card className="my-3">
              <Card.Body>
                {saving && (
                  <Alert variant="info" className="p-3">
                    <p className="loading-msg">saving note..</p>
                    <ProgressBar variant="info" animated now={100} />
                  </Alert>
                )}
                {!saving && <>
                  {message!=='' && (
                    <Alert variant="warning" className="p-3">{message}</Alert>
                  )}

                  {mode===0 && <>
                    {parseInt(_.get(props,'note.id',0)) > 0 && <Alert variant="info" className="mb-3">{_.get(props,'note.note','')}</Alert>}

                    {userData.is_rota && viewOnly===false && <>
                      {parseInt(_.get(props,'note.id',0)) > 0 && <div className="text-end">
                        <Button variant="primary" size="sm" className="shadow m-1" onClick={() => setMode(1)}>Edit</Button>
                        <Button variant="danger" size="sm" className="shadow m-1" onClick={deleteNote}>Delete</Button>
                      </div>}
                    </>}
                  </>}

                  {mode===1  && viewOnly===false && <textarea className="form-control" rows="5" name="note" id="note" placeholder="Enter your note here" defaultValue={_.get(props,'note.note','')}></textarea>}
                    
                    
                  </>}
                
                
              </Card.Body>
            </Card>
          </Modal.Body>
          {!saving && mode===1  && viewOnly===false && <Modal.Footer className="text-cemter">
              {parseInt(_.get(props,'note.id',0)) > 0 && <Button variant="secondary" size="sm" className="shadow m-1" onClick={() => setMode(0)}>Cancel</Button>}
              <Button type="submit" variant="primary" className="py-1 px-4">Submit</Button>
          </Modal.Footer>}
        </Form>
      </Modal>
    </>
  );
};

export default RotaNote;
